import { GetStaticProps } from "next";
import getTranslations from "../lib/getTranslations";
import Terms from "@whoppah/components/terms/Terms";

const TermsPage = () => {
  return <Terms />;
};

TermsPage.getLayout = (page: JSX.Element) => page;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await getTranslations(locale, ["terms"])),
    },
  };
};

export default TermsPage;
